<template>
    <div v-cloak>
        <b-form-checkbox
            v-model="allSelected"
            :indeterminate="indeterminate"
            @change="toggleAllLevels"
        >
            {{ allSelected ? 'Un-select all' : 'Select all Levels' }}
        </b-form-checkbox>

        <b-form-checkbox-group
            v-model="selectedLevels"
            :required="preSelectedLevel !==''"
        >
            <b-form-checkbox
                v-for="level in levels"
                :key="level"
                :value="level"
                :disabled="disabled.includes(level)"
            >
                {{ level }}
            </b-form-checkbox>
        </b-form-checkbox-group>
    </div>
</template>

<script>
/* global _ */
export default {
    props: {
        preSelectedLevel: {
            type: String,
            required: false,
            default: () => '',
        },
        disable: {
            default: false,
            validator(val) {
                if (_.isArray(val) || _.isBoolean(val)) {
                    return true;
                }
                return false;
            },
        },
    },
    data() {
        return {
            selectedLevels: [],
            levels: [
                'Level 1',
                'Level 2',
                'Level 3',
                'Level 4',
            ],
            allSelected: false,
            indeterminate: false,
        };
    },
    computed: {
        actualSelectedLevels() {
            return this.selectedLevels.map(levelLabel => Number(levelLabel.slice(-1)));
        },
        disabled() {
            const disabled = [];
            if (_.isArray(this.disable)) {
                this.disable.forEach((el) => {
                    disabled.push(`Level ${el}`);
                });
            }
            return disabled;
        },
    },
    watch: {
        selectedLevels() {
            if (this.selectedLevels.length === 0) {
                this.indeterminate = false;
                this.allSelected = false;
            } else if (this.selectedLevels.length === this.levels.length) {
                this.indeterminate = false;
                this.allSelected = true;
            } else {
                this.indeterminate = true;
                this.allSelected = false;
            }
        },
        actualSelectedLevels() {
            this.$emit('bulk-levels', this.actualSelectedLevels);
        },
        preSelectedLevel() {
            this.selectedLevels = [this.preSelectedLevel];
        },
    },
    mounted() {
        if (this.preSelectedLevel) {
            this.selectedLevels.push(this.preSelectedLevel);
        }
    },
    methods: {
        resetLevels() {
            this.selectedLevels = [];
        },
        toggleAllLevels(checked) {
            // find out all toggable levels
            const toggles = this.levels.filter(el => !(this.disabled.includes(el)));
            toggles.forEach((el) => {
                const index = this.selectedLevels.indexOf(el);

                if (checked && index === -1) {
                    // it's missing so add it
                    this.selectedLevels.push(el);
                }

                // it's there so remove it
                if (!checked && index !== -1) {
                    this.selectedLevels.splice(index, 1);
                }
            });
        },
    },
};
</script>
